import { render, staticRenderFns } from "./ServicesMainMenu.vue?vue&type=template&id=23c92ae9&scoped=true"
import script from "./ServicesMainMenu.vue?vue&type=script&lang=js"
export * from "./ServicesMainMenu.vue?vue&type=script&lang=js"
import style0 from "./ServicesMainMenu.vue?vue&type=style&index=0&id=23c92ae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c92ae9",
  null
  
)

export default component.exports